import React from "react";
import ReactDOM from "react-dom";

import App from "./pages/App";
ReactDOM.render(<App></App>, document.getElementById("root"));
